import { useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';

function PaymentCancelled() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get('tx') || searchParams.get('transaction_id') || searchParams.get('reference');
  const isFailed = location.pathname.includes('failed') || searchParams.get('reason') === 'failed' || searchParams.get('status') === 'failure';

  useEffect(() => {
    const params = new URLSearchParams();
    if (transactionId) params.set('tx', transactionId);
    params.set('status', isFailed ? 'failure' : 'canceled');
    navigate(`/pay?${params.toString()}`, { replace: true });
  }, [navigate, transactionId, isFailed]);

  return null;
}

export default PaymentCancelled;
